import React from "react";

//Fades / slides its children in the first time they scroll into view (like the original site's entrance animations)
const Reveal = ({ as: Tag = "div", className = "", variant = null, delay = 0, style = {}, children, ...props }) => {
  const ref = React.useRef(null);
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    const el = ref.current;
    if (!el) {
      return undefined;
    }
    if (!("IntersectionObserver" in window)) {
      setIsVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const classes = [
    "reveal",
    variant ? `reveal-${variant}` : "",
    isVisible ? "is-visible" : "",
    className,
  ].join(" ");

  return (
    <Tag
      ref={ref}
      className={classes}
      style={{ ...style, "--delay": `${delay}s` }}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
